var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJohor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 1800 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1800v900H0z",
    fill: "#002b7f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h900v600H0z",
    fill: "#ce1126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M495.740995 119.012972a230 230 0 1 0-80.958364 364.312639 200 200 0 1 1 80.958364-364.312639zM450.9284 173.759916l79.524189 144.118437-133.077957 96.873516 161.639125-31.096952 51.008819 156.500221 20.374271-163.337411L795 376.666667l-149.047113-69.85112 50.721505-156.593581-112.490453 120.167045z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJohor);
export default __webpack_public_path__ + "static/media/johor.62a2b6ea2dd4731be5af2e0c6feaee03.svg";
export { ForwardRef as ReactComponent };